<template>
  <div v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header>
     <div class="content">
    <div class="mt--6">
      <div class="row">
        <div class="col-lg-12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card v-if="editor === 'super-admin'">
              <!-- Card header -->
              <h3 slot="header" class="mb-0"></h3>
              <!-- Card body -->
              <validation-observer ref="formValidator">
                <form class="needs-validation">
                  <!-- Input groups with icon -->
                  <div class="row">
                    <div class="col-md-12">
                      <base-input
                        label="Name"
                        readonly
                        v-model="account.interface"
                        placeholder="Interface"
                      class="input-style"
                   ></base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <base-input
                        type="email"
                        label="Email"
                        readonly
                        v-model="account.email"
                        placeholder="Email"
                        class="input-style"
                      ></base-input>
                    </div>
                    <div class="col-md-12">
                      <base-input
                        label="Password"
                        name="Password"
                        v-model="account.password"
                        rules="required"
                        placeholder="Password"
                        type="text"
                        class="input-style"
                      ></base-input>
                    </div>
                  </div>
                  <div class="text-right">
                    <base-button
                      type="primary"
                      native-type="submit"
                      @click.prevent="updatePassword"
                      >Update</base-button
                    >
                  </div>
                </form>
              </validation-observer>
            </card>
            <card v-if="editor === 'company' || editor === 'manager'|| editor === 'sub-admin'" class="form-style">
              <template slot="header">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <h5 class="mb-0">General Information</h5>
                  </div>
                  <div class="flex-grow-1 pr-3 text-right">
                    <!-- <span class="edit-btn">
                      <base-button class="greybtn font-weight-normal pl-3 pr-4 py-2 h6">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.0347 3.01505C16.5732 2.47645 17.2963 2.16281 18.0575 2.13774C18.8187 2.11267 19.5609 2.37804 20.1337 2.88005L20.2777 3.01505L20.9847 3.72205C21.523 4.26047 21.8365 4.98343 21.8615 5.74439C21.8866 6.50534 21.6214 7.24737 21.1197 7.82005L20.9847 7.96405L9.77268 19.177C9.61416 19.3356 9.42212 19.4565 9.21068 19.531L9.04868 19.578L4.59468 20.6061C4.43862 20.6423 4.27612 20.6406 4.12087 20.601C3.96562 20.5614 3.82217 20.485 3.70259 20.3784C3.583 20.2717 3.4908 20.1379 3.43374 19.9882C3.37667 19.8385 3.35642 19.6772 3.37468 19.518L3.39468 19.4051L4.42168 14.95C4.47242 14.7315 4.57152 14.5272 4.71168 14.352L4.82268 14.227L16.0347 3.01505ZM15.3277 6.55005L6.33768 15.54L5.70168 18.298L8.45968 17.661L17.4497 8.67105L15.3277 6.55005ZM18.8637 4.42905C18.6915 4.25687 18.4624 4.15344 18.2194 4.13816C17.9763 4.12288 17.7361 4.1968 17.5437 4.34605L17.4497 4.42905L16.7417 5.13605L18.8637 7.25705L19.5707 6.55005C19.7429 6.37786 19.8463 6.14876 19.8616 5.90573C19.8769 5.6627 19.8029 5.42245 19.6537 5.23005L19.5707 5.13605L18.8637 4.42905Z" fill="#656565"/>
                        </svg>
                      Edit
                    </base-button>

                    </span> -->
                    <!-- <span>
                      <span class="requireField">*</span> Indicates a required
                      field.
                    </span> -->
                  </div>
                </div>
              </template>
              <!-- Card header -->
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form
                  class="needs-validation"
                  @submit.prevent="handleSubmit(updateAccoount)"
                >

                <!-- <div class="d-flex align-items-center mb-4">
                    <div class="img-block position-relative mr-3">
                      <img class="profile-img" src="img/theme/avatar.svg" width="79" height="79" />
                      <div class="input-file position-absolute">
                        <input type="file">
                        <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="39.5" cy="39.5" r="39.5" fill="#FE672C" fill-opacity="0.5"/>
                          <path d="M33.1668 33.1667H35.5418L37.1252 31.5834H41.8752L43.4585 33.1667H45.8335C46.2534 33.1667 46.6561 33.3335 46.9531 33.6305C47.25 33.9274 47.4168 34.3301 47.4168 34.75V44.25C47.4168 44.67 47.25 45.0727 46.9531 45.3696C46.6561 45.6666 46.2534 45.8334 45.8335 45.8334H33.1668C32.7469 45.8334 32.3442 45.6666 32.0472 45.3696C31.7503 45.0727 31.5835 44.67 31.5835 44.25V34.75C31.5835 34.3301 31.7503 33.9274 32.0472 33.6305C32.3442 33.3335 32.7469 33.1667 33.1668 33.1667ZM39.5002 35.5417C38.4503 35.5417 37.4435 35.9587 36.7012 36.7011C35.9589 37.4434 35.5418 38.4502 35.5418 39.5C35.5418 40.5499 35.9589 41.5567 36.7012 42.299C37.4435 43.0413 38.4503 43.4584 39.5002 43.4584C40.55 43.4584 41.5568 43.0413 42.2991 42.299C43.0415 41.5567 43.4585 40.5499 43.4585 39.5C43.4585 38.4502 43.0415 37.4434 42.2991 36.7011C41.5568 35.9587 40.55 35.5417 39.5002 35.5417ZM39.5002 37.125C40.1301 37.125 40.7341 37.3753 41.1795 37.8207C41.6249 38.2661 41.8752 38.8702 41.8752 39.5C41.8752 40.1299 41.6249 40.734 41.1795 41.1794C40.7341 41.6248 40.1301 41.875 39.5002 41.875C38.8703 41.875 38.2662 41.6248 37.8208 41.1794C37.3754 40.734 37.1252 40.1299 37.1252 39.5C37.1252 38.8702 37.3754 38.2661 37.8208 37.8207C38.2662 37.3753 38.8703 37.125 39.5002 37.125Z" fill="white"/>
                        </svg>
                      </div>
                    </div>
                    <div class="img-content">
                      <div>Profile Photo</div>
                      <div>300x300 jpg.png</div>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-4">
                    <div class="img-block position-relative mr-3">
                      <img class="profile-img" src="img/theme/avatar.svg" width="79" height="79" />
                      <span class="status-icon"></span>
                    </div>
                    <div class="img-content">
                      <div>Profile Photo</div>
                      <div>300x300 jpg.png</div>
                    </div>
                </div> -->

                  <div class="row mb-0 mb-md-2">
                    <div class="col-md-6">
                      <label class="form-control-label"
                        >First Name <span class="requireField">*</span></label
                      >
                      <base-input
                        name="First Name"
                        placeholder="First Name"
                        rules="required"
                        v-model="companydata.first_name"
                      >
                      </base-input>
                    </div>
                    <div class="col-md-6">
                      <label class="form-control-label"
                        >Last Name <span class="requireField">*</span></label
                      >
                      <base-input
                        name="Last Name"
                        placeholder="Last Name"
                        rules="required"
                        v-model="companydata.last_name"
                      >
                      </base-input>
                    </div>
                  </div>
                    <div class="row mb-0 mb-md-2">
                    <div class="col-md-6"
                      v-if="companydata.user_type != 'employee'"
                    >
                      <label class="form-control-label"
                        >Email Address <span class="requireField">*</span></label
                      >
                      <base-input
                        type="email"
                        name="Email Address"
                        rules="required|email"
                        placeholder="Email Address"
                        v-model="companydata.email"
                      >
                      </base-input>
                    </div>

                    <div class="col-md-6" v-else>
                      <base-input
                        label="Email Address"
                        name="Email Address"
                        placeholder="Email Address"
                        v-model="companydata.email"
                      >
                      </base-input>
                    </div>
                    <div class="col-md-6">
                      <base-input
                        label="Mobile Number"
                        name="Phone number"
                        placeholder="Phone number"
                        v-model="companydata.phone_num"
                        @input="acceptNumber"
                      >
                      </base-input>
                    </div>
                    </div>
                    <div class="row mb-0 mb-md-2">

                    <div class="col-md-6">
                      <base-input
                        label="Address"
                        name="Address"
                        placeholder="Address"
                        v-model="companydata.address"
                      >
                      </base-input>
                    </div>
                    <div class="col-md-6">
                      <base-input
                        label="City"
                        name="City"
                        placeholder="City"
                        v-model="companydata.city"
                      >
                      </base-input>
                    </div>
                  </div>
                    <div class="row mb-0 mb-md-2">
                    <div class="col-md-6">
                      <base-input
                        label="State"
                        name="State"
                        placeholder="State"
                        v-model="companydata.state"
                      >
                      </base-input>
                    </div>
                    <div class="col-md-6">
                      <base-input
                        label="Zip Code"
                        name="Zip Code"
                        placeholder="Zip code"
                        v-model="companydata.zipcode"
                      >
                      </base-input>
                    </div>
                  </div>
                    <div class="row mb-0 mb-md-2">

                    <div class="col-md-6">
                      <label class="form-control-label">Date of birth</label>
                      <el-date-picker
                        v-model="companydata.dob"
                        class = "form-group"
                        placeholder="Pick a day"
                        style="width: 100%"
                        format="MM/dd/yyyy"
                        :picker-options="pickerOptions1"
                      >
                      </el-date-picker>
                    </div>

                    <div class="col-md-6">
                      <label class="form-control-label"
                        >Username <span class="requireField">*</span></label
                      >
                      <base-input
                        name="Username"
                        rules="required"
                        readonly
                        v-model="companydata.user_name"
                      >
                      </base-input>
                    </div>
                  </div>
                    <div class="row mb-0 mb-md-2">
                    <div class="col-md-6">
                      <label class="form-control-label"
                        >Password <span class="requireField">*</span></label
                      >
                      <base-input
                        name="Password"
                        placeholder="Password"
                        :rules="{ required: true }"
                        v-model="companydata.password"
                        type="password"
                      >
                      </base-input>
                    </div>
                  </div>
                  <div class="row mb-0 mb-md-2">
                    <div class="col-md-12">
                      <div class="notification-pref-card">
                        <div>
                          <label class="form-control-label mb-1">Email Notifications</label>
                          <p class="mb-0 text-muted small">
                            Turn this off to unsubscribe from training and platform email notifications.
                          </p>
                        </div>
                        <label class="switch mb-0">
                          <input
                            type="checkbox"
                            v-model="notificationPreferences.emailNotifications"
                            :disabled="notificationPreferences.isLoading"
                          >
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>


                  <div class="d-flex justify-content-between justify-content-sm-end py-2">
                    <base-button class="greybtn font-weight-normal px-5 mr-1 mr-sm-3">Cancel</base-button>
                      <base-button type="primary" class="font-weight-normal px-4" native-type="submit"
                      >Save & Update</base-button>
                  </div>
                </form>
              </validation-observer>
            </card>
          </div>
        </div>
      </div>
    </div>
     </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import FileInput from "@/components/Inputs/FileInput";

export default {
  name: "form-components",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      loading: false,
      account: {
        password: "",
        interface: "Super Admin",
        email: "admin@homeoftraining.com"
      },
      editor: "",
      updateCardInfoModal: false,
      validated: false,
      baseUrl: this.$baseUrl,
      complete: false,
      image: "",
      files: [],
      company_id: "",
      company_name: "",
      user_id: "",
      admin_id: "",
      companydata: {
        first_name: "",
        last_name: "",
        email: "",
        phone_num: "",
        password: "",
        user_name: "",
        address: "",
        city: "",
        state: "",
        social_security: "",
        dob: "",
        new_password: "",
        confirm_password: ""
      },
      notificationPreferences: {
        emailNotifications: true,
        isLoading: false,
        suppressNextChange: false,
        isReverting: false
      },
      pickerOptions1: {
        shortcuts: []
      }
    };
  },
  created: function() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }

    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
      this.admin_id = localStorage.getItem("hot-user-id");
    }else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.user_id = localStorage.getItem("hot-user-id");
     } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
      this.user_id = localStorage.getItem("hot-admin-id");
      this.company_id = localStorage.getItem("hot-user-id");
      this.companyName = localStorage.getItem("hot-company-name");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
      this.user_id = localStorage.getItem("hot-user-id");
    }
    if (this.editor == "company" || this.editor == "manager" || this.editor == "sub-admin") {
      this.loading = true;
      this.$http
        .get("employees/get/" + this.user_id)
        .then(resp => {
          let data = resp.data[0];
          let obj = {
            user_name: data.user_name,
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            phone_num: data.phone_num,
            password: "", // Don't show password/access_code for security
            address: data.address,
            city: data.city,
            state: data.state,
            dob: data.dob,
            zipcode: data.zipcode,
            social_security: data.social_security,
            user_type: data.type
          };
          this.companydata = obj;
          this.loadNotificationPreference();
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    "notificationPreferences.emailNotifications"(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.notificationPreferences.suppressNextChange) {
        this.notificationPreferences.suppressNextChange = false;
        return;
      }
      if (this.notificationPreferences.isReverting) {
        this.notificationPreferences.isReverting = false;
        return;
      }
      this.onNotificationToggle(oldValue);
    }
  },
  methods: {
    loadNotificationPreference() {
      if (!this.user_id) {
        return;
      }
      this.notificationPreferences.isLoading = true;
      this.$http
        .get("unsubscribe/status/" + this.user_id)
        .then(resp => {
          const isUnsubscribed = !!(resp.data && resp.data.is_unsubscribed);
          this.notificationPreferences.suppressNextChange = true;
          this.notificationPreferences.emailNotifications = !isUnsubscribed;
        })
        .finally(() => {
          this.notificationPreferences.isLoading = false;
        });
    },
    syncNotificationPreference() {
      return this.$http.post("unsubscribe/toggle", {
        user_id: this.user_id,
        unsubscribe: !this.notificationPreferences.emailNotifications
      });
    },
    onNotificationToggle(previousValue) {
      this.notificationPreferences.isLoading = true;

      this.syncNotificationPreference()
        .then(() => {
          Swal.fire({
            title: "Notification Preferences",
            text: this.notificationPreferences.emailNotifications
              ? "You are subscribed to email notifications."
              : "You have unsubscribed from email notifications.",
            icon: "success",
            confirmButtonText: "Ok"
          });
        })
        .catch(() => {
          this.notificationPreferences.isReverting = true;
          this.notificationPreferences.emailNotifications = previousValue;
          Swal.fire({
            title: "Error!",
            text: "Unable to update notification preference. Please try again.",
            icon: "error",
            confirmButtonText: "Ok"
          });
        })
        .finally(() => {
          this.notificationPreferences.isLoading = false;
        });
    },
    acceptNumber() {
      var x = this.companydata.phone_num
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.companydata.phone_num = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    updatePassword() {
      if (this.account.password !== "") {
        this.$http
          .post("super_admin/update_password", {
            id: this.admin_id,
            password: this.account.password
          })
          .then(resp => {
            Swal.fire({
              title: "Password",
              text: "Changed Successfully",

              icon: "success",
              confirmButtonText: "Ok"
            });
          });
      } else {
        Swal.fire({
          text: "Password field is required!!",
          icon: "warning",
          confirmButtonText: "Ok"
        });
      }
    },

    async updateAccoount() {
      if (
        this.companydata.first_name == "" ||
        this.companydata.last_name == "" ||
        this.companydata.password == "" ||
        this.companydata.user_name == ""
      ) {
        Swal.fire({
          title: "Error!",
          text: `Please fill all required feilds.`,
          icon: "error"
        });
      } else {
        let data = {
          employee_first_name: this.companydata.first_name,
          employee_last_name: this.companydata.last_name,
          employee_email: this.companydata.email,
          employee_phone_num: this.companydata.phone_num,
          employee_access_code: this.companydata.password,
          employee_address: this.companydata.address,
          employee_city: this.companydata.city,
          employee_state: this.companydata.state,
          employee_zipcode: this.companydata.zipcode,
          employee_dob: this.companydata.dob
        };


        this.$http.put("employees/update/" + this.user_id, data).then(async resp => {
          await this.syncNotificationPreference();
          Swal.fire({
            title: "Success!",
            text: `Employee has been Updated!`,
            icon: "success",
            confirmButtonText: "Ok"
          }).then(() => {
            // Redirect to dashboard after successful update
            this.$router.push("/dashboard");
          });
        });
      }
    }
  }
};
</script>
<style>
.stripe-card {
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
.logo-size {
  width: 60%;
  height: auto;
}
.notification-pref-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c9ced6;
  transition: .2s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .2s;
}
input:checked + .slider {
  background-color: #FE672C;
}
input:focus + .slider {
  box-shadow: 0 0 1px #FE672C;
}
input:checked + .slider:before {
  transform: translateX(22px);
}
.slider.round {
  border-radius: 24px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>
